import React from "react";
import { useI18n } from "../i18n/i18n";

export default function SiteFooter() {
  const { t } = useI18n();
  return (
    <footer className="siteFooter">
      {t("footer.copyright", { year: "2025" })}
    </footer>
  );
}
